import { render, staticRenderFns } from "./ProblemEdit.html?vue&type=template&id=7deb22bc&scoped=true&external"
import script from "./ProblemEdit.ts?vue&type=script&lang=ts&external"
export * from "./ProblemEdit.ts?vue&type=script&lang=ts&external"
import style0 from "./ProblemEdit.scss?vue&type=style&index=0&id=7deb22bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb22bc",
  null
  
)

export default component.exports